import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { BoxForm, CodeField, NumberField, Switch, TagsField } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { EditPaapiSchema, WorkspaceBidder } from '../schemas/editPaapiSchema'
import { KNOWLEDGE_BASE_URL } from './constants'

export const ParametersSection = (): JSX.Element => {
  const ability = useAbility()
  const { t: tc } = useTranslation('common')
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'prebid.modules.general.edit.general.paapi.parameters',
  })

  const { control, getValues } = useFormContext<EditPaapiSchema>()

  const isDisabled: boolean = ability.cannot('update', 'GlobalSetupFeature-general')

  return (
    <Paper>
      <SectionHeader
        subtitle={t('subtitle')}
        title={t('title')}
      />

      <GapBox />

      <BoxForm>
        <TagsField
          control={control}
          disabled={isDisabled}
          label={t('bidders.label')}
          name='bidders'
          options={getValues('meta.workspaceBidders').map(
            ({ bidderCode }: WorkspaceBidder): string => bidderCode,
          )}
          tooltip={{ content: t('bidders.tooltip') }}
        />

        <NumberField
          control={control}
          disabled={isDisabled}
          label={t('defaultForSlots.label')}
          name='defaultForSlots'
          tooltip={{ content: t('defaultForSlots.tooltip') }}
        />

        <CodeField
          control={control}
          disabled={isDisabled}
          language='json'
          name='componentSeller'
          options={{
            folding: false,
            lineNumbers: 'off',
          }}
          title={t('componentSeller.label')}
          tooltip={{
            content: t('componentSeller.tooltip'),
            link: {
              title: tc('learnMore'),
              url: KNOWLEDGE_BASE_URL.componentSeller,
            },
          }}
        />

        <Switch
          control={control}
          disabled={isDisabled}
          label={t('parallel.label')}
          labelPlacement='start'
          name='parallel'
          tooltip={{
            content: t('parallel.tooltip'),
            link: {
              title: tc('learnMore'),
              url: KNOWLEDGE_BASE_URL.parallel,
            },
          }}
        />

        <Switch
          control={control}
          disabled={isDisabled}
          label={t('paapiForGpt.label')}
          labelPlacement='start'
          name='paapiForGpt'
          tooltip={{
            content: t('paapiForGpt.tooltip'),
            link: {
              title: tc('learnMore'),
              url: KNOWLEDGE_BASE_URL.paapiForGpt,
            },
          }}
        />
      </BoxForm>
    </Paper>
  )
}
